import React, { Fragment, FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { Player, TeamGameMatch, TeamGameMatchTeam } from '../../../../../database.schema';
import * as CSS from '../../match-entry-styles';
import { FlexRowSpaceEvenly, Button } from '../../../common-styles/common-styles';

type PairsDisplayProps = {
  selectedTournamentIndex: number;
  players: Array<Player>;
  matchIndex: number;
  match: TeamGameMatch;
};

export const PairsDisplay: FC<PairsDisplayProps> = ({ match, selectedTournamentIndex, players, matchIndex }): JSX.Element => {
  const navigate = useNavigate();

  const scoresEntered = (team: TeamGameMatchTeam): boolean => {
    return team.players.some((player) => player.round.courseHandicap !== -1);
  };

  return (
    <Fragment>
      {match.matchPlayMatches?.map((pairsMatch, pairsIndex: number) => (
        <CSS.MatchWrapper key={`stored-match-${pairsIndex}`} data-testid="match-wrapper">
          <h3>{`Pairs Match ${pairsIndex + 1}`}</h3>
          <FlexRowSpaceEvenly>
            <CSS.CreatedMatch data-testid={`team-1-0`} bgColour={'red'}>
              <div>
                {pairsMatch.team1.playerIds.map((playerId: number, playerIndex) => (
                  <div data-testid={`team-1-${pairsIndex}-player-${playerIndex}`} key={`team-1-player-${playerId}`}>
                    {players.find((player1: Player) => player1.id === playerId)?.nickName}
                  </div>
                ))}
              </div>
            </CSS.CreatedMatch>
            V
            <CSS.CreatedMatch data-testid={`team-2-0`} bgColour={'blue'}>
              <div>
                {pairsMatch.team2.playerIds.map((playerId: number, playerIndex) => (
                  <div data-testid={`team-2-${pairsIndex}-player-${playerIndex}`} key={`team-2-player-${playerId}`}>
                    {players.find((player1: Player) => player1.id === playerId)?.nickName}
                  </div>
                ))}
              </div>
            </CSS.CreatedMatch>
          </FlexRowSpaceEvenly>
          <Button
            data-testid={`enter-scores-${pairsIndex}`}
            onClick={() => {
              navigate(`/${scoresEntered(match.teams[0]) ? 'edit' : 'add'}-team-game-matchplay-scorecard/${selectedTournamentIndex}/${matchIndex}/${pairsIndex}`);
            }}
          >
            {scoresEntered(match.teams[0]) ? 'Edit scores' : 'Add scores'}
          </Button>
        </CSS.MatchWrapper>
      ))}
    </Fragment>
  );
};
